var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('image-to-text-results-base-page',{attrs:{"allow-library":true},on:{"select-from-library":_vm.openSelectFromLibraryModal},scopedSlots:_vm._u([{key:"page-not-found",fn:function(){return [_c('page-not-found')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }